import { useEffect, useState } from 'react';
import { listenToCurrentSubscription, type StripeSubscriptionSummary } from '../lib/stripeBilling';

export function useStripeSubscription(uid?: string | null) {
  const [subscription, setSubscription] = useState<StripeSubscriptionSummary | null>(null);
  const [allSubscriptions, setAllSubscriptions] = useState<StripeSubscriptionSummary[]>([]);
  const [loading, setLoading] = useState(Boolean(uid));

  useEffect(() => {
    if (!uid) {
      setSubscription(null);
      setAllSubscriptions([]);
      setLoading(false);
      return;
    }

    setLoading(true);
    const unsubscribe = listenToCurrentSubscription(uid, (nextSubscription, all) => {
      setSubscription(nextSubscription);
      setAllSubscriptions(all);
      setLoading(false);
    });

    return unsubscribe;
  }, [uid]);

  return { subscription, allSubscriptions, loading };
}
